export default "__VITE_ASSET__BUKXzKbI__"